import { RESOLUTION_ENTITY_TYPE } from '../../constants/common';
import { COMPETITIVE_TRENDS_METRIC_1_LIST } from '../../constants/formMeta/growthTrends';
import {
  CNP_RESOLVE_RECOMMENDATION_OPTIONS,
  CR_CHANGE_STATUS,
  RESOLVE_RECOMMENDATION_OPTIONS,
} from '../../constants/formMeta/recommendation';

// TODO: copy all trends helper methods from common.js to here and write tests for them.
const trendsHelper = {
  // method to get appropriate link to redirect from growth Trends Events tab
  getRedirectLinkFromEventType: (id: string, type: string, topTrendList: any[]) => {
    let redirectLink, redirectAs;
    if (type == RESOLUTION_ENTITY_TYPE.TOP_OPPORTUNITY) {
      redirectLink = `/app/opportunities/top-opportunities?id=${id}`;
    } else if (type == RESOLUTION_ENTITY_TYPE.USABILITY_RECOMMENDATIONS) {
      redirectLink = '/app/trends/growth-trends/[id]?site-detail=true';
      redirectAs = `/app/trends/growth-trends/${id}?site-detail=true`;
    } else if (type == RESOLUTION_ENTITY_TYPE.CONTENT_RECOMMENDATIONS) {
      redirectLink = '/app/content-recommendations/details/[id]';
      redirectAs = `/app/content-recommendations/details/${id}`;
    } else if (type == RESOLUTION_ENTITY_TYPE.CNP) {
      redirectLink = '/app/content-recommendations/content-brief/details/[id]';
      redirectAs = `/app/content-recommendations/content-brief/details/${id}`;
    } else if (type == 'setup') {
      redirectLink = '/app/settings/setup';
      redirectAs = `/app/settings/setup`;
    } else {
      const foundTopTrend = topTrendList.find((i) => i.id == id);
      const isMarketShareMetric = COMPETITIVE_TRENDS_METRIC_1_LIST.find(
        (metric) => metric?.value == foundTopTrend?.trend_definition?.filters?.metric_1
      );
      if (foundTopTrend && isMarketShareMetric) {
        // If first metric is market share redirect to market share page
        redirectLink = '/app/trends/competitive-trends/[id]';
        redirectAs = `/app/trends/competitive-trends/${id}`;
      } else {
        redirectLink = '/app/trends/growth-trends/[id]';
        redirectAs = `/app/trends/growth-trends/${id}`; // else redirect to growth trend
      }
    }
    return { redirectLink, redirectAs };
  },

  getEventSubtypeDisplayText: (annotation_subtype: string, isCnpPage = false) => {
    let resolutionData = isCnpPage ? CNP_RESOLVE_RECOMMENDATION_OPTIONS : RESOLVE_RECOMMENDATION_OPTIONS;
    resolutionData = [...resolutionData, ...CR_CHANGE_STATUS];
    const subTypeObject = resolutionData.find((obj) => obj?.value == annotation_subtype);
    return subTypeObject?.text || '';
  },

  joinFilterValues: (filterValues: string[]) => {
    return filterValues
      .map((selectedValue) => {
        return selectedValue ? selectedValue.replace(',', '^,') : '';
      })
      .join(',');
  },
};

export default trendsHelper;
